module.exports = __webpack_public_path__ + "img/scanCreationWhite.43cb3457.svg";